// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "冷热源工程",
      "tec": "刘钧哲张小辉",
      "week": "1-12周",
      "add": "教学楼B座321能动"
    },
    0,
    {
      "sub": "机械设计基础",
      "tec": "徐秀玲孙泰鹏",
      "week": "1-12周",
      "add": "教学楼C座311教务"
    },
    0,
    0
  ],
  "2": [
    {
      "sub": "建筑环境学",
      "tec": "项敬岩",
      "week": "1-11周",
      "add": "教学楼B座321能动"
    },
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "李芗霓",
        "week": "1-8周",
        "add": "图书馆1楼党史+网络数字教育基地"
      },
      {
        "sub": "国家安全教育",
        "tec": "李芗霓",
        "week": "9-12周",
        "add": "图书馆1楼党史+网络数字教育基地"
      }
    ],
    {
      "sub": "劳动与创造",
      "tec": "王建宇",
      "week": "13周",
      "add": "教学楼B座219能动"
    },
    {
      "sub": "劳动与创造",
      "tec": "王建宇",
      "week": "13周",
      "add": "教学楼B座219能动"
    },
    {
      "sub": "就业创业指导",
      "tec": "秦玲",
      "week": "6-10周",
      "add": "教学楼C座110教务"
    }
  ],
  "3": [
    {
      "sub": "冷热源工程",
      "tec": "刘钧哲张小辉",
      "week": "1-12周",
      "add": "教学楼B座317能动"
    },
    {
      "sub": "热质交换原理与设备",
      "tec": "崔洁",
      "week": "1,3,5,7,9周",
      "add": "教学楼B座317能动"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "机械设计基础",
      "tec": "徐秀玲孙泰鹏",
      "week": "1-12周",
      "add": "教学楼C座308教务"
    },
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "李芗霓",
        "week": "1-8周",
        "add": "图书馆1楼党史+网络数字教育基地"
      },
      {
        "sub": "国家安全教育",
        "tec": "李芗霓",
        "week": "9-12周",
        "add": "图书馆1楼党史+网络数字教育基地"
      }
    ],
    {
      "sub": "劳动与创造",
      "tec": "王建宇",
      "week": "13周",
      "add": "教学楼B座220能动"
    },
    {
      "sub": "劳动与创造",
      "tec": "王建宇",
      "week": "13周",
      "add": "教学楼B座220能动"
    },
    0
  ],
  "5": [
    [
      {
        "sub": "冷热源工程",
        "tec": "刘钧哲张小辉",
        "week": "1,3,5,7,9,11周",
        "add": "教学楼B座321能动"
      },
      {
        "sub": "建筑环境学",
        "tec": "项敬岩",
        "week": "2,4,6,8,10周",
        "add": "教学楼B座321能动"
      }
    ],
    {
      "sub": "热质交换原理与设备",
      "tec": "崔洁",
      "week": "1-11周",
      "add": "教学楼B座321能动"
    },
    {
      "sub": "冷热源工程",
      "tec": "刘钧哲张小辉",
      "week": "10,12周",
      "add": "教学楼B座219能动"
    },
    {
      "sub": "工程伦理",
      "tec": "金钰刘洪抵",
      "week": "1-8周",
      "add": "教学楼B座324能动"
    },
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
